var A;!function(A){A[A.ADMIN=0]="ADMIN",A[A.MAINTENANCE_DASHBOARD=1]="MAINTENANCE_DASHBOARD",A[A.DASHBOARD=2]="DASHBOARD",A[A.DRIVER_DASHBOARD=3]="DRIVER_DASHBOARD"}(A||(A={}));var D=A;export{D as default};
